import { Card, CardContent, Grid, Typography, useTheme } from "@mui/material";

const CardComp = ({
  data,
  content,
  maxHeight = "auto",
  onClick = () => {},
}) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 5,
        overflow: "hidden",
        margin: "2px",
        height: maxHeight,
        border: `1px solid ${theme.palette.secondary.main}`,
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: 6,
        },
      }}
      onClick={() => onClick(data)}
    >
      <CardContent sx={{ p: "8px !important", pb: "12px !important" }}>
        {content}
      </CardContent>
    </Card>
  );
};

export function InputDisplay({ label, value }) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={4}>
        <Typography variant="body2" gutterBottom className="card-text">
          <span
            style={{ color: theme.palette.primary.main, fontWeight: "bold" }}
          >
            {label}
          </span>{" "}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" gutterBottom className="card-text">
          {value}
        </Typography>
      </Grid>
    </>
  );
}

export default CardComp;
